<template>
  <div style="width: 100%;">
    <div v-if="loading" class="col-12" style="margin-top: 20px;">
      <inline-alert-component
        message="Gráfico Donut de Ligações (Atendidas x Abandonadas)..."
        type="primary"
      />
    </div>

    <div v-else class="card-charts my-3 px-3 py-3">
      <div class="sub-card-donut">
        <h3 style="color: #000; text-align: center">
          <i class="fas fa-phone-alt"></i> Ligações (Atendidas x Abandonadas)
        </h3>
        <hr />
        <apexchart
          type="donut"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DonutChartsCallsReport",
  props: {
    filter: {
      type: Object,
      required: true,
      default: () => ({ startDate: "", endDate: "", queue: "*" }),
    },
  },
  data() {
    return {
      loading: false,
      series: [], // [totalAtendidas, totalAbandonadas]
      chartOptions: {
        chart: {
          id: "pizzaChartAnsweredAbandonedReport",
          type: "donut",
          toolbar: {
            show: true,
            tools: { download: true }
          }
        },
        labels: ["Ligações atendidas", "Ligações abandonadas"],
        colors: ["53e713", "FF0000"],
        legend: { position: "top" },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: "Total",
                  fontSize: "1.4em",
                  fontWeight: 600,
                  color: "#373d3f",
                  formatter: (w) => {
                    const s = w.globals.seriesTotals || [];
                    const sum = s.reduce((a, b) => a + b, 0);
                    return String(sum);
                  },
                },
                value: {
                  show: true,
                  fontSize: "1.6em",
                  fontWeight: 700,
                },
              },
            },
          },
        },
        dataLabels: {
          style: {
            fontSize: "1.1em",
            fontWeight: "bold",
          },
        },
        noData: { text: "Sem dados para exibir no momento..." },
      },
    };
  },
  methods: {
    getCalls() {
      if (!this.filter || !this.filter.startDate || !this.filter.endDate) {
        console.log('Filtros inválidos:', this.filter);
        return;
      }
      this.loading = true;

      // Usar queueIds se disponível, senão usar queue
      let queueParam = "*";
      if (this.filter.queueIds && this.filter.queueIds !== "*") {
        queueParam = this.filter.queueIds;
      } else if (this.filter.queue && this.filter.queue !== "*") {
        if (Array.isArray(this.filter.queue)) {
          queueParam = this.filter.queue.join(',');
        } else {
          queueParam = this.filter.queue;
        }
      }

      const params = new URLSearchParams({
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        queue: queueParam,
      });

      const url = `${window.location.href}/callsPizzaChartReport?${params.toString()}`;
      
      console.log('URL da requisição:', url);
      console.log('Parâmetros:', {
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        queue: queueParam
      });

      axios.get(url)
        .then(({ data }) => {
          console.log('Resposta da API:', data);
          // Somatórios: (≤1min + >1min) por grupo
          const totalAtendidas =
            (data?.answered?.Menor1minEspera || 0) +
            (data?.answered?.Maior1minEspera || 0);

          const totalAbandonadas =
            (data?.abandoned?.Menor1minEspera || 0) +
            (data?.abandoned?.Maior1minEspera || 0);

          console.log('Totais calculados:', { totalAtendidas, totalAbandonadas });
          this.series = [totalAtendidas, totalAbandonadas];
        })
        .catch((error) => {
          console.error("Erro ao carregar donut:", error);
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler() {
        this.getCalls();
      },
    },
  },
};
</script>

<style scoped>
.card-charts {
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 12px;
  box-shadow: -5px -5px 8px rgba(255,255,255,1),
              -2px -2px 12px rgba(255,255,255,0.5),
               inset 2px 2px 4px rgba(255,255,255,0.1),
               5px 5px 8px rgba(0,0,0,0.15);
}
.sub-card-donut { width: 55%; min-width: 340px; }
</style>
